const Builder = require('./BuilderBase');
const TextColumn = require('./listColumns/TextColumn');
const ForeignRelationTextColumn = require('./listColumns/ForeignRelationTextColumn');
const DateTimeColumn = require('./listColumns/DateTimeColumn');
const CustomizableVisibility = require('./CustomizableVisibility');
const HiddenFor = require('./HiddenFor');

module.exports = class DownloadButton extends Builder {
    constructor(title, properties) {
        super('actionElement_DownloadButton', title, properties);
    }
    textColumn(title, properties) {
        let column = new TextColumn(title, properties);
        this.addChildBlock(column, 'columns');
        return this;
    }
    foreignRelationTextColumn(title, properties) {
        let column = new ForeignRelationTextColumn(title, properties);
        this.addChildBlock(column, 'columns');
        return this;
    }
    dateTimeColumn(title, properties) {
        let column = new DateTimeColumn(title, properties);
        this.addChildBlock(column, 'columns');
        return this;
    }

    /**
     *
     * @param {object} properties
     * @param {string} properties.title
     * @param {boolean} [properties.isTabAccess]
     * @param {string} properties.accessTargetId
     * @param {boolean} properties.readOnly
     */
    customizableVisibility(properties) {
        let modifier = new CustomizableVisibility({ isTabAccess: false, ...properties });
        this.addChildBlock(modifier, 'securityModifier');
        return this;
    }
    hiddenFor(role) {
        let modifier = new HiddenFor(role);
        this.addChildBlock(modifier, 'securityModifier');
        return this;
    }
};
